import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {OverlayRef, OverlayConfig} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-modal-audit-cancel',
  templateUrl: './modal-audit-cancel.component.html',
  styles: []
})
export class ModalAuditCancelComponent extends ExcTranslation implements OnInit {

  data = {
    Comment: null,
    cancelReason: null
  };
  constructor(
    private overlayRef: OverlayRef,
    private excSec: ExcSigninService,
    private overlayConfig: OverlayConfig,
    private datePipe: DatePipe,
    private excDss: DefaultSettingsService
  ) {
    super();
  }

  ngOnInit() {
  }

  getEnumerationStornoGrund(): any[] {
    return this.excDss.Enumeration.filter((enm: any) => enm.enmName === 'enum_Stornogrund');
  }

  proceed() {
    const _self = this;

    const comment = _self.getRessource('CommentSchemeReason', {date: _self.datePipe.transform((new Date()), _self.getGlobal('FormatDateTime'))
        , user: _self.excSec.Profile.DisplayName
        , reason: this.data.Comment});

    this.overlayRef.close({proceed: true, Comment: comment, cancelReason: this.data.cancelReason});
  }
}
